/**
 * NOTE: Below are the "registered" feature flags that can be used within the
 *       application. Ideally, we should filter out any other features returned
 *       by LaunchDarkly and other gating services so that we only utilize the
 *       ones that are known. This will also help us with future maintainence of
 *       feature flags within those respective services so we can clean them up
 *       after they have been fully released.
 */

/**
 * Feature flags
 */
export const NEW_NAV = 'NEW_NAV';

/**
 * Route flags
 */
export const NEXT_FLOWS_LIST_PAGE = 'NEXT_FLOWS_LIST_PAGE';
